import { db } from '../firebase';
import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,
  query,
  limit,
  startAfter,
  QueryDocumentSnapshot,
} from 'firebase/firestore';
import type { PricePlan } from '../types/pricePlans';

const PRICE_PLANS_COLLECTION = 'price_plans';

export async function getPricePlans(pageSize?: number, lastDoc?: QueryDocumentSnapshot): Promise<{ pricePlans: PricePlan[]; lastDoc?: QueryDocumentSnapshot }> {
  console.log('[API] getPricePlans called', { pageSize, lastDoc });
  const plansRef = collection(db, PRICE_PLANS_COLLECTION);
  let q = query(plansRef);
  if (pageSize) {
    q = query(q, limit(pageSize));
    if (lastDoc) {
      q = query(q, startAfter(lastDoc));
    }
  }
  const snapshot = await getDocs(q);
  const pricePlans = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as PricePlan));
  const newLastDoc = snapshot.docs[snapshot.docs.length - 1];
  return { pricePlans, lastDoc: newLastDoc };
}

export async function getPricePlanById(id: string): Promise<PricePlan | null> {
  console.log('[API] getPricePlanById called', { id });
  const ref = doc(db, PRICE_PLANS_COLLECTION, id);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() } as PricePlan;
}

export async function addPricePlan(plan: Omit<PricePlan, 'id'>): Promise<string> {
  console.log('[API] addPricePlan called', { plan });
  const ref = doc(collection(db, PRICE_PLANS_COLLECTION));
  await setDoc(ref, plan);
  return ref.id;
}

export async function updatePricePlan(id: string, data: Partial<PricePlan>): Promise<void> {
  console.log('[API] updatePricePlan called', { id, data });
  const ref = doc(db, PRICE_PLANS_COLLECTION, id);
  await updateDoc(ref, data);
}

export async function deletePricePlan(id: string): Promise<void> {
  console.log('[API] deletePricePlan called', { id });
  const ref = doc(db, PRICE_PLANS_COLLECTION, id);
  await deleteDoc(ref);
} 